module.exports = __webpack_public_path__ + "img/videoUnMute.b447f708.svg";